import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import TrustSection from "@/components/TrustSection";
import SEO from "@/components/SEO";
import { ArrowRight, MousePointerClick, FileUp, Wand2, CalendarCheck } from "lucide-react";

const STEPS = [
  {
    icon: MousePointerClick,
    title: "1. Sorununuzu seçin",
    text: "Abonelik iptali, fatura itirazı, iade ya da hakem heyeti — hangisi olduğunu belirleyin ve kartlar üzerinden ilerleyin.",
  },
  {
    icon: FileUp,
    title: "2. Belgenizi yükleyin (opsiyonel)",
    text: "Fatura, ekran görüntüsü veya sipariş bilgisini yükleyebilirsiniz. Belge yoksa adımı atlayabilirsiniz.",
  },
  {
    icon: Wand2,
    title: "3. Metniniz hazırlansın",
    text: "Abonelik İptal, sorununuza uygun Türkçe başvuru/itiraz metnini, gerekli belge listesini ve doğru başvuru yolunu hazırlar.",
  },
  {
    icon: CalendarCheck,
    title: "4. Takip planınızı kullanın",
    text: "Kontrol tarihleri ve sonraki adımları görün. Tekrar fatura kesilirse hakem heyeti dosyası oluşturun.",
  },
];

export default function HowItWorks() {
  return (
    <div>
      <SEO
        title="Abonelik İptal Nasıl Çalışır? | Abonelik İptal"
        description="Dört basit adımda iptal, iade veya itiraz dosyanızı Abonelik İptal ile hazırlayın. Kart tabanlı ve Türkçe süreç."
        path="/nasil-calisir"
      />
      <Header />
      <section className="max-w-4xl mx-auto px-5 md:px-8 pt-14 md:pt-20 pb-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#4DA6A1] mb-3">
          Nasıl Çalışır?
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-[#0F3D4A] tracking-tight">
          Karmaşık formlar yok. Sadece dört basit adım.
        </h1>
        <p className="mt-5 text-lg text-[#0F3D4A]/75 leading-relaxed max-w-2xl">
          Abonelik İptal, tüketici olarak yaşadığınız iptal, iade ve itiraz süreçlerini
          birkaç kart seçimiyle çözülebilir hâle getirir. Her adım açık,
          Türkçe ve kısa.
        </p>
        <div className="mt-8">
          <Link
            to="/dosya-baslat"
            data-testid="howworks-cta"
            className="fs-btn-primary inline-flex items-center gap-2"
          >
            Başvuru Hazırla <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 md:px-8 mt-8 md:mt-12 space-y-5">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={i}
              data-testid={`howworks-step-${i}`}
              className="fs-card p-6 md:p-8 flex gap-5 items-start"
            >
              <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center shrink-0">
                <Icon size={24} className="text-[#0F3D4A]" strokeWidth={2.25} />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-[#0F3D4A]">
                  {s.title}
                </h3>
                <p className="mt-2 text-[#0F3D4A]/75 leading-relaxed">
                  {s.text}
                </p>
              </div>
            </div>
          );
        })}
      </section>

      <TrustSection />
      <Footer />
    </div>
  );
}
